module.exports = __webpack_public_path__ + "static/media/fr.d831e6a2.svg";